import { LoadingButton } from "@mui/lab";
import { Grid, Card, FormControl, TextField, Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "../../store/store";

import './forgotPassword.scss';
import { forgotPasswordSendOtp, forgotPasswordVerifyOtp, resetAccountPassword } from "../../store/api/authentication";
import SuccessDialog from "../../components/dialogBox/successDialog/successDialog";
import { PAGES_URL } from "../../shared/constants/constants";

const ForgotPassword = () => {

    const storeForgotPasswordState = useSelector((state: RootState) => state.authentication);
    const navigate = useNavigate();

    const [pagePurpose, setPagePurpose] = useState<"GET_USERNAME" | "VERIFY_OTP" | "SET_PASSWORD" | "">("GET_USERNAME");

    const [email, setEmail] = useState({
        value: '',
        isError: false,
        errorMsg: '',
    });
    const [password, setPassword] = useState({
        value: '',
        isError: false,
        errorMsg: '',
    });
    const [otp, setOtp] = useState({
        value: '',
        isError: false,
        errorMsg: ''
    });
    const [counter, setCounter] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [tempAuthToken, setTempAuthToken] = useState(null);
    const [success, setSuccess] = useState({ open: false, message: '' });

    const validateInput = (emailVal?: string, passwordval?: string) => {
        let isValid = true;
        if (!emailVal || emailVal === undefined) {
            isValid = false;
            setEmail((prevState) => ({
                ...prevState,
                isError: true,
                errorMsg: 'Please enter email',
            }));
        } else {
            setEmail((prevState) => ({
                ...prevState,
                isError: false,
                errorMsg: '',
            }));
        }

        if (passwordval !== undefined) {
            if (!passwordval) {
                isValid = false;
                setPassword((prevState) => ({
                    ...prevState,
                    isError: true,
                    errorMsg: 'Please enter password',
                }));
            } else {
                setPassword((prevState) => ({
                    ...prevState,
                    isError: false,
                    errorMsg: '',
                }));
            }
        }

        return isValid;
    }

    useEffect(() => {
        if (pagePurpose === "VERIFY_OTP") {
            if (!canResend && counter > 0) {
                const timer = setTimeout(() => setCounter(counter - 1), 1000);
                return () => clearTimeout(timer);
            }

            if (counter === 0) {
                setCanResend(true);
            }
        }
    }, [counter, canResend, pagePurpose]);

    const minutes = Math.floor(counter / 60);
    const seconds = counter % 60;
    const formattedCounter = `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;

    const handleSendOtp = async (mode: string = "") => {
        try {
            if (mode === "RESEND" && !canResend) {
                return;
            }

            const reqBody = {
                username: email.value,
            }
            const response = await store.dispatch(forgotPasswordSendOtp(reqBody)).unwrap();
            setCounter(60);
            setCanResend(false);
            setPagePurpose("VERIFY_OTP");
        }
        catch (error: any) {
            // console.log("Error occurred at handleSendOtp", error);
            setEmail((prevState) => ({
                ...prevState,
                isError: true,
                errorMsg: error?.error ?? error?.message ?? "Error sending otp to the registered email.",
            }));
        }
    }

    const handleVerifyOtp = async () => {
        try {
            const reqBody = {
                username: email.value,
                otp: otp.value,
            }
            const response = await store.dispatch(forgotPasswordVerifyOtp(reqBody)).unwrap();
            setTempAuthToken(response.data?.authorizationToken);
            setPagePurpose("SET_PASSWORD");
            
        }
        catch (error: any) {
            setOtp((prevState) => ({
                ...prevState,
                isError: true,
                errorMsg: error?.error ?? error?.message ?? "Error verifying otp.",
            }));
        }
    }

    const handleResetPassword = async () => {
        try {
            const reqBody = {
                data: {
                    username: email.value,
                    password: password.value,
                },
                authToken: tempAuthToken,
            }
            const response = await store.dispatch(resetAccountPassword(reqBody)).unwrap();
            setSuccess({ open: true, message: response?.data?.message ?? "Successfully updated the password. Please login to continue." })
        }
        catch (error: any) {
            // console.log("Error occurred at handleResetPassword", error);
            setPassword((prevState) => ({
                ...prevState,
                isError: true,
                errorMsg: error?.error ?? error?.message ?? "Error reseting account password.",
            }));
        }
    }

    const handleCloseSuccess = () => {
        setSuccess({ ...success, open: false });
        navigate(PAGES_URL?.HOME);
    };

    return (
        <div className='wrapper'>
            <Grid className='container'
                container
                component={'main'}
                sx={{
                    justifyContent: { xs: 'center', lg: 'flex-start' },
                }}
            >
                {pagePurpose === "GET_USERNAME" && (<Grid item xs={false} sm={6} lg={6} className='container-item-1'>
                    <Card
                        className='content-card'
                        sx={{
                            p: 2,
                        }}
                        raised
                    >
                        <div className='content_title'>Forgot Password</div>
                        <p className="content_subtitle">
                            Please enter your registered email address.{" "}
                        </p>
                        <FormControl fullWidth sx={{ mt: 2 }} variant='standard' className='input_field'>
                            <TextField
                                id='email'
                                variant='standard'
                                type="email"
                                placeholder='Email'
                                value={email.value}
                                error={email.isError}
                                helperText={email.errorMsg}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setEmail((prevState) => ({
                                        ...prevState,
                                        value: event.target.value,
                                    }));
                                    validateInput(event.target.value);
                                }}
                                className='input_text'
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <LoadingButton className='submit-btn'
                                loading={storeForgotPasswordState.loading}
                                loadingPosition='center'
                                variant='contained'
                                sx={{ borderRadius: 20, fontWeight: 'bold' }}
                                onClick={() => handleSendOtp()}
                            >
                                Login
                            </LoadingButton>
                        </FormControl>
                    </Card>
                </Grid>)}

                {pagePurpose === "VERIFY_OTP" && (<Grid
                    item
                    xs={false}
                    sm={6}
                    lg={6}
                    className="container-item-1"
                    sx={{ width: "100%" }}
                >
                    <Card
                        className="content-card"
                        sx={{
                            p: 4,
                        }}
                        raised
                    >
                        <div className="content_title">Buyer, Verify your account</div>
                        <p className="content_subtitle">
                            We are sending an OTP to your registered email-id{" "}
                        </p>
                        <Box sx={{ width: "100%" }}>
                            <OtpInput
                                value={otp.value}
                                onChange={(value) => setOtp(() => ({ isError: false, errorMsg: '', value: value }))}
                                numInputs={6}
                                inputType="number"
                                shouldAutoFocus={true}
                                renderSeparator={<span style={{ width: "27px" }}></span>}
                                renderInput={(props) => (
                                    <input {...props} inputMode="numeric" />
                                )}
                                inputStyle={{
                                    width: "53px",
                                    height: "58px",
                                    border: "1px solid #E6E6E6",
                                    fontSize: "16px",
                                    borderBottomColor: `${!otp.isError ? "#ED1B24" : "#E6E6E6"}`,
                                }}
                            />
                        </Box>
                        <Typography
                            sx={{
                                color: "Red",
                                display: `${otp.isError ? "block" : "none"}`,
                                fontWeight: "400",
                                fontSize: "16px",
                                lineHeight: "24px",
                                mt: 2,
                                width: 1,
                            }}
                        >
                            {otp.errorMsg}
                        </Typography>
                        <FormControl fullWidth>
                            <LoadingButton
                                className="submit-btn"
                                loading={storeForgotPasswordState.loading}
                                loadingPosition="center"
                                variant="contained"
                                sx={{ borderRadius: 20, fontWeight: "bold" }}
                                onClick={() => handleVerifyOtp()}
                                disabled={otp.value.length !== 6 ? true : false}
                            >
                                Verify
                            </LoadingButton>
                        </FormControl>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Typography
                                    sx={{
                                        fontFamily: "Poppins",
                                        fontWeight: 400,
                                        fontSize: "16px",
                                        lineHeight: "24px",
                                    }}
                                >
                                    Didn’t receive the code?&nbsp;
                                </Typography>

                                <Typography
                                    sx={{ color: canResend ? "#15993E" : "grey", textDecoration: "none", cursor: canResend ? "pointer" : "default" }}
                                    onClick={() => handleSendOtp("RESEND")}
                                >
                                    {canResend ? "Resend" : `${formattedCounter} Seconds`}
                                </Typography>

                            </Box>
                        </FormControl>
                    </Card>
                </Grid>)}

                {pagePurpose === "SET_PASSWORD" && (<Grid item xs={false} sm={6} lg={6} className='container-item-1'>
                    <Card
                        className='content-card'
                        sx={{
                            p: 4,
                        }}
                        raised
                    >
                        <div className='content_title'>Enter new password</div>
                        <p className="content_subtitle">
                            Please enter your new password.{" "}
                        </p>
                        <FormControl fullWidth sx={{ mt: 2 }} variant='standard' className='input_field'>
                            <TextField
                                id='password'
                                type='password'
                                variant='standard'
                                placeholder='Password'
                                error={password.isError}
                                helperText={password.errorMsg}
                                value={password.value}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setPassword((prevState) => ({
                                        ...prevState,
                                        value: event.target.value,
                                    }));
                                    validateInput(undefined, event.target.value);
                                }}
                                className='input_text'
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <LoadingButton className='submit-btn'
                                loading={storeForgotPasswordState.loading}
                                loadingPosition='center'
                                variant='contained'
                                sx={{ borderRadius: 20, fontWeight: 'bold' }}
                                onClick={() => handleResetPassword()}
                            >
                                Submit
                            </LoadingButton>
                        </FormControl>
                    </Card>
                </Grid>)}

                <Grid item xs={false} sm={6} lg={6} className='container-item-2'>
                    <img src={""} alt="Sign In Image" />
                </Grid>
            </Grid>

            <SuccessDialog
                open={success.open}
                message={success.message}
                onClose={handleCloseSuccess}
            />
        </div>


    );
}

export default ForgotPassword